module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('crumbs', [_c('i', {
    staticClass: "glyphicon glyphicon-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.profitShareViewLan.title))])]), _vm._v(" "), _c('div', {
    staticClass: "principal-wrap"
  }, [_c('div', {
    staticClass: "region-box pull-left"
  }, [_c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.profitshare_area), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.curArea
      },
      on: {
        "click": function($event) {
          return _vm.areaGroupSwitchFn(item)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n              ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('btn-group', {
    staticClass: "primary-box pull-right"
  }, [_c('btn', {
    class: {
      'active': (_vm.activePrimary == '/accountSetting')
    },
    on: {
      "click": function($event) {
        return _vm.jump('/profit/accountSetting')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.profitShareViewLan.account_setting) + "\n          ")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Report') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.profitShareViewLan.profit_report))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.profitShareViewLan.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "curArea": _vm.curArea
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e64e8664","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProfitShareSetting/ProfitShareView.vue
// module id = 1145
// module chunks = 1